import { z } from 'zod';
import { zStringRequired } from '../../z';
export const stPlanOfCareValidationSchema = z.object({
    id: z.string().optional(),
    data: z.object({
        treatmentPlan: z.object({
            stEval: z.string().optional(),
            patientAgrees: z.boolean().optional(),
            patientAgreesTo: z.string().optional(),
        }),
        neuromuscularExercises: z.object({
            periOralMm: z.boolean().optional(),
            intraOralMm: z.boolean().optional(),
            pharyngealMm: z.boolean().optional(),
            laryngealMm: z.boolean().optional(),
            masticationMm: z.boolean().optional(),
            facialMm: z.boolean().optional(),
            purpose: z.boolean().optional(),
            swallowing: z.boolean().optional(),
            speech: z.boolean().optional(),
            coordination: z.boolean().optional(),
            other: z.boolean().optional(),
            otherText: z.string().nullable().optional(),
        }),
        communicationExercises: z.object({
            expressiveLanguage: z.boolean().optional(),
            verbal: z.boolean().optional(),
            nonVerbal: z.boolean().optional(),
            written: z.boolean().optional(),
            receptiveLanguage: z.boolean().optional(),
            auditory: z.boolean().optional(),
            reading: z.boolean().optional(),
            augmentationDevices: z.boolean().optional(),
            other: z.boolean().optional(),
            otherText: z.string().nullable().optional(),
        }),
        vocalRetraining: z.object({
            vocalStrengthening: z.boolean().optional(),
            vocalClarity: z.boolean().optional(),
            follow: z.boolean().optional(),
            other: z.boolean().optional(),
            otherText: z.string().nullable().optional(),
        }),
        nmEstim: z.object({
            parameters: z.string().optional(),
        }),
        diaphragmExercise: z.object({
            coughing: z.boolean().optional(),
            clearingThroat: z.boolean().optional(),
            vocalNeeds: z.boolean().optional(),
        }),
        cognitiveTraining: z.object({
            vocalStrengthening: z.boolean().optional(),
            shortTermMemory: z.boolean().optional(),
            sequencing: z.boolean().optional(),
            organizational: z.boolean().optional(),
            other: z.boolean().optional(),
            otherText: z.string().nullable().optional(),
        }),
        ptcgEducation: z.object({
            swallowingStrategies: z.boolean().optional(),
            foodConsistency: z.boolean().optional(),
            posturalSetup: z.boolean().optional(),
            aspirationPrecautions: z.boolean().optional(),
            voiceProsthetic: z.boolean().optional(),
            trachCare: z.boolean().optional(),
            other: z.boolean().optional(),
            otherText: z.string().nullable().optional(),
        }),
        frequencyOfVisits: z.object({
            entries: z
                .array(z.object({
                noOfVisits: z.string().optional(),
                recurring: z.string().optional(),
                duration: z.string().optional(),
            }))
                .optional(),
            otherDisciplineRecommend: z.array(z.string()).optional(),
            patientShowImprovement: z.string().optional(),
        }),
    }),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
